export default __webpack_public_path__ + "static/media/image-hero-desktop.631209c1.jpg";